import { ApiTypes } from "@agroyaar/sdk";
import { client } from "@new-services/lib/sdk";
import { unwrapResult } from "@new-services/utils";

export const getMechanizationVarieties = async (
  variables: ApiTypes.Varieties["RequestParams"]["getAll"]
) => {
  const result = await client.dashboardServices.varieties.getAll({
    params: variables.params,
  });
  return unwrapResult(result);
};

export const getMechanization = async (
  variables: ApiTypes.Mechanization["RequestParams"]["getOne"]
) => {
  const result = await client.dashboardServices.mechanization.getOne(variables);
  return unwrapResult(result);
};

export const getMechanizations = async (
  variables: ApiTypes.Mechanization["RequestParams"]["getAll"]
) => {
  const result = await client.dashboardServices.mechanization.getAll(variables);
  return unwrapResult(result);
};

export const deleteMechanization = async (
  variables: ApiTypes.Mechanization["RequestParams"]["delete"]
) => {
  const result = await client.dashboardServices.mechanization.delete(variables);
  return unwrapResult(result);
};

export const getSeasonsProcess = async () => {
  const result =
    await client.dashboardServices.seasonsProcess.getSeasonsProcess();
  return unwrapResult(result);
};

export const getMechanizationSensors = async (
  variables: ApiTypes.MechanizationSensor["RequestParams"]["getSensors"]
) => {
  const result = await client.dashboardServices.mechanizationSensors.getMechanizationSensors(
    variables
  );
  return unwrapResult(result);
};

export const getSpeedChangesChartData = async (
  variables: ApiTypes.MechanizationSensor["RequestParams"]["getSpeedChange"]
) => {
  const result = await client.dashboardServices.mechanizationSensors.getSpeedChanges(
    variables
  );
  return unwrapResult(result);
};

export const postMechanizationDeviceCode = async (
  variables: ApiTypes.MechanizationDeviceCode["RequestParams"]["create"]
) => {
  const result = await client.dashboardServices.mechanizationDeviceCode.create(variables);
  return unwrapResult(result);
};

export const updateMechanizationDeviceCode = async (
  variables: ApiTypes.MechanizationDeviceCode["RequestParams"]["update"]
) => {
  const result = await client.dashboardServices.mechanizationDeviceCode.update(variables);
  return unwrapResult(result);
};

export const deleteMechanizationDeviceCode = async (
  variables: ApiTypes.MechanizationDeviceCode["RequestParams"]["delete"]
) => {
  const result = await client.dashboardServices.mechanizationDeviceCode.delete(variables);
  return unwrapResult(result);
};

export const verifyPhoneNumber = async (
  variables: ApiTypes.Auth["RequestParams"]["createVerifyPhoneNumber"]
) => {
  const result = await client.dashboardServices.auth.verifyPhoneNumber(
    variables
  );
  return unwrapResult(result);
};

export const getMechanizationQuestion = async (
  variables: ApiTypes.MechanizationQuestion["RequestParams"]["getAll"]
) => {
  const result = await client.dashboardServices.mechanizationQuestion.getAll(
    variables
  );
  return unwrapResult(result);
};

export const createMechanization = async (
  variables: ApiTypes.Mechanization["RequestParams"]["create"]
) => {
  const result = await client.dashboardServices.mechanization.create(variables);
  return unwrapResult(result);
};

export const getMechanizationMovementChanges = async (
  variables: ApiTypes.MechanizationSensor["RequestParams"]["getMovementChange"]
) => {
  const result =
    await client.dashboardServices.mechanizationSensors.getMechanizationMovementChanges(
      variables
    );
  return unwrapResult(result);
};

export const getMechanizationTemperatureChanges = async (
  variables: ApiTypes.MechanizationSensor["RequestParams"]["getTemperatureChanges"]
) => {
  const result =
    await client.dashboardServices.mechanizationSensors.getMechanizationTemperatureChanges(
      variables
    );
  return unwrapResult(result);
};

export const getMechanizationFuelConsumptionChanges = async (
  variables: ApiTypes.MechanizationSensor["RequestParams"]["getFuelConsumptionChanges"]
) => {
  const result =
    await client.dashboardServices.mechanizationSensors.getMechanizationFuelConsumptionChanges(
      variables
    );
  return unwrapResult(result);
};

export const getCroppingPatterns = async (
  variables: ApiTypes.CroppingPattern["RequestParams"]["getAll"]
) => {
  const result = await client.dashboardServices.croppingPattern.getAll(
    variables
  );
  return unwrapResult(result);
};
export const getCroppingPattern = async (
  variables: ApiTypes.CroppingPattern["RequestParams"]["getOne"]
) => {
  const result = await client.dashboardServices.croppingPattern.getOne(
    variables
  );
  return unwrapResult(result);
};

export const getExperimentsList = async (
  variables: ApiTypes.Experiments["RequestParams"]["getExperiments"]
) => {
  const result = await client.dashboardServices.experiment.getListExperiments(
    variables
  );
  return unwrapResult(result);
};
export const getCroppingSuitability = async (
  variables: ApiTypes.CroppingSuitability["RequestParams"]["getOne"]
) => {
  const result = await client.dashboardServices.croppingSuitability.getOne(
    variables
  );
  return unwrapResult(result);
};

export const getPlantsTypeList = async () => {
  const result = await client.dashboardServices.statics.getPlantType();
  return unwrapResult(result);
};

export const getProductsTypeList = async (
  variables: ApiTypes.Products["RequestParams"]["getProducts"]
) => {
  const result = await client.dashboardServices.products.getProducts(variables);
  return unwrapResult(result);
};

export const createCroppingPattern = async (
  variables: ApiTypes.CroppingPattern["RequestParams"]["create"]
) => {
  const result = await client.dashboardServices.croppingPattern.create(
    variables
  );
  return unwrapResult(result);
};

export const getCroppingSuitabilities = async (
  variables: ApiTypes.CroppingSuitability["RequestParams"]["getAll"]
) => {
  const result = await client.dashboardServices.croppingSuitability.getAll(
    variables
  );
  return unwrapResult(result);
};

export const createCroppingSuitabilities = async (
  variables: ApiTypes.CroppingSuitability["RequestParams"]["create"]
) => {
  const result = await client.dashboardServices.croppingSuitability.create(
    variables
  );
  return unwrapResult(result);
};

export const getIrrigationSource = async (
  variables: ApiTypes.IrrigationSource["RequestParams"]["getOne"]
) => {
  const result = await client.dashboardServices.irrigationSource.getOne(variables);
  return unwrapResult(result);
};

export const postIrrigationSourceDeviceCode = async (
  variables: ApiTypes.IrrigationSourceDeviceCode["RequestParams"]["create"]
) => {
  const result = await client.dashboardServices.irrigationSourceDeviceCode.create(variables);
  return unwrapResult(result);
};

export const updateIrrigationSourceDeviceCode = async (
  variables: ApiTypes.IrrigationSourceDeviceCode["RequestParams"]["update"]
) => {
  const result = await client.dashboardServices.irrigationSourceDeviceCode.update(variables);
  return unwrapResult(result);
};

export const deleteIrrigationSourceDeviceCode = async (
  variables: ApiTypes.IrrigationSourceDeviceCode["RequestParams"]["delete"]
) => {
  const result = await client.dashboardServices.irrigationSourceDeviceCode.delete(variables);
  return unwrapResult(result);
};

export const getIrrigationSensors = async (
  variables: ApiTypes.IrrigationSourceSensor["RequestParams"]["getSensors"]
) => {
  const result = await client.dashboardServices.irrigationSourceSensors.getIrrigationSensors(
    variables
  );
  return unwrapResult(result);
};

export const getEngineVibrationLevelChanges = async (
  variables: ApiTypes.IrrigationSourceSensor["RequestParams"]["getEngineVibrationLevelChanges"]
) => {
  const result = await client.dashboardServices.irrigationSourceSensors.getEngineVibrationLevelChanges(
    variables
  );
  return unwrapResult(result);
};

export const getStatePowerChanges = async (
  variables: ApiTypes.IrrigationSourceSensor["RequestParams"]["getStatePowerChanges"]
) => {
  const result = await client.dashboardServices.irrigationSourceSensors.getStatePowerChange(
    variables
  );
  return unwrapResult(result);
};

export const getStatePumpChanges = async (
  variables: ApiTypes.IrrigationSourceSensor["RequestParams"]["getStatePumpChanges"]
) => {
  const result = await client.dashboardServices.irrigationSourceSensors.getStatePumpChanges(
    variables
  );
  return unwrapResult(result);
};

export const getConsumptionApmsChanges = async (
  variables: ApiTypes.IrrigationSourceSensor["RequestParams"]["getConsumptionAmpsChanges"]
) => {
  const result = await client.dashboardServices.irrigationSourceSensors.getConsumptionAmpsChanges(
    variables
  )
  return unwrapResult(result);
};